import { Modal, Col, Button, Table, Badge } from "reactstrap";
import ModalLibraryMatchingTerms from "./ModalLibraryMatchingTerms";
import ModalContestationForm from "./ModalContestationForm";
import ModalContestationStatus from "./ModalContestationStatus";
import {
  tableHeaderStyle,
  tableHeaderStyleCenter,
  tableContentStyle,
} from "assets/css/custom-components";
import { useEffect, useState } from "react";

const libraryMatchSpeaker = {
  0: "Cliente",
  1: "Consultor",
};

const ModalLibraryMatchDetails = ({
  libraryTitle,
  matchType,
  matches,
  attendance,
  attendanceName,
  contestation,
  updateAttendance,
  setUpdateAttendance,
  scoreRule,
  permissions,
  isContestationExpired,
}) => {
  const [toggle, setToggle] = useState(false);
  const [groupedBySpeaker, setGroupedBySpeaker] = useState({});

  useEffect(() => {
    if (matches) {
      const grouped = matches.reduce((acc, match) => {
        const speaker = match.speaker;
        if (!acc[speaker]) {
          acc[speaker] = [];
        }
        acc[speaker].push(match);
        return acc;
      }, {});
      setGroupedBySpeaker(grouped);
    }
  }, [matches]);

  return (
    <Col lg="12" style={{ padding: 0 }}>
      <Button
        className="Button"
        size="sm"
        color="primary"
        onClick={() => setToggle(true)}
      >
        Detalhes
      </Button>
      <Modal
        className="modal-dialog modal-xl"
        style={{ marginTop: "50px" }}
        isOpen={toggle}
        toggle={() => setToggle((v) => !v)}
      >
        <div className="modal-header">
          <div className="modal-title">
            <h3>
              Detalhes dos enquadramentos - <u>{libraryTitle}</u>
            </h3>
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setToggle((v) => !v)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {Object.keys(groupedBySpeaker).length > 0 ? (
            Object.keys(groupedBySpeaker).map((speaker) => (
              <div key={speaker} className="mb-4">
                <h5 className="mb-3">
                  <Badge color="info" className="mr-2">
                    {libraryMatchSpeaker[speaker]}
                  </Badge>
                </h5>
                <Table
                  style={{
                    tableLayout: "fixed",
                    width: "100%",
                  }}
                  className="table-striped"
                >
                  <thead>
                    <tr className="custom-head">
                      <th scope="col" title="Event ID" style={tableHeaderStyle}>
                        Event ID
                      </th>
                      <th
                        scope="col"
                        title="Total de Termos"
                        style={tableHeaderStyleCenter}
                      >
                        Total de Termos
                      </th>
                      <th
                        scope="col"
                        title="Data/Hora"
                        style={tableHeaderStyle}
                      >
                        Data/Hora
                      </th>
                      <th
                        scope="col"
                        title="Scores"
                        style={tableHeaderStyleCenter}
                      >
                        Scores
                      </th>
                      <th
                        scope="col"
                        title="Ações"
                        style={tableHeaderStyleCenter}
                      >
                        Termos
                      </th>
                      {permissions?.includes("read:quality:contestation") && (
                        <th
                          scope="col"
                          title="Contestação"
                          style={tableHeaderStyleCenter}
                        >
                          Contestação
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {groupedBySpeaker[speaker].map((match, index) => (
                      <tr key={index} className="custom-tr">
                        <td style={tableContentStyle}>{match.eventId}</td>
                        <td style={{ textAlign: "center" }}>
                          {match.totalTerms}
                        </td>
                        <td style={tableContentStyle}>
                          {new Date(match.createdAt).toLocaleString("pt-BR")}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {match.scores && match.scores.length > 0
                            ? match.scores.reduce(
                                (sum, score) => sum + score.score,
                                0,
                              )
                            : "Sem scores"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <ModalLibraryMatchingTerms
                            matchType={matchType}
                            terms={match.terms}
                          />
                        </td>
                        {permissions?.includes("read:quality:contestation") && (
                          <td style={{ textAlign: "center" }}>
                            {(() => {
                              const contestationData = contestation?.find(
                                (item) =>
                                  item.attendanceLibraryMatchId ===
                                  match.id?.toString(),
                              );

                              const libraryRules = scoreRule?.filter(
                                (rule) =>
                                  rule.libraryId?.id === match.libraryId,
                              );

                              if (contestationData) {
                                return (
                                  <ModalContestationStatus
                                    contestation={contestationData}
                                    updateAttendance={updateAttendance}
                                    setUpdateAttendance={setUpdateAttendance}
                                    scoreRule={libraryRules}
                                    libraryId={match.libraryId}
                                    attendanceLibraryMatchId={match.id}
                                    clientId={attendance?.client?.id}
                                  />
                                );
                              } else if (
                                permissions?.includes(
                                  "create:quality:contestation",
                                )
                              ) {
                                if (isContestationExpired) {
                                  return (
                                    <span
                                      style={{
                                        color: "red",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Prazo expirado
                                    </span>
                                  );
                                } else {
                                  return (
                                    <ModalContestationForm
                                      attendanceId={attendance?.id}
                                      attendanceLibraryMatchId={match.id}
                                      segmentId={attendance?.segment?.id}
                                      attendanceName={attendanceName}
                                      response={`Enquadramento de biblioteca: ${libraryTitle} (${matchType}) - Event ${match.eventId}`}
                                      updateAttendance={updateAttendance}
                                      setUpdateAttendance={setUpdateAttendance}
                                    />
                                  );
                                }
                              }
                              return null;
                            })()}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))
          ) : (
            <p>Nenhum enquadramento encontrado para esta biblioteca.</p>
          )}
        </div>
      </Modal>
    </Col>
  );
};

export default ModalLibraryMatchDetails;
